<template>
    <div>
        <div>
            <el-form :model="$parentInfo.dialog_UpdateAccount"
                     label-width="90px">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="原账号">
                            <el-input v-model="$parentInfo.dialog_UpdateAccount.phone"
                                      placeholder="请输入账号" disabled style="width: 200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="新账号">
                            <el-input v-model="$parentInfo.dialog_UpdateAccount.new_phone"
                                      placeholder="请输入新账号"  style="width: 200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateAccount"
                       :loading="$parentInfo.dialog_UpdateAccount.button_loading">发送短信
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_UpdateAccount",
        data() {
            return {
                activeTab: 1,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetStudentAccount('');
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
        },
        beforeDestroy(){
            this.$parentInfo.dialog_UpdateAccount.new_phone=''
        },
        methods: {
            handleGetStudentAccount() {
                this.$wApi.send(this.$parentInfo.path, 'get_employeeAccount', {
                    'employee_id':this.$store.state.modal.data.employee_id,
                });
            },
            handleUpdateAccount(){
                this.$confirm('确认绑定?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_UpdateAccount.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'update_employeeAccount', {
                        'employee_id':this.$store.state.modal.data.employee_id,
                        'new_phone':this.$parentInfo.dialog_UpdateAccount.new_phone,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>